import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {LinkSubjectToGroupContainerModel} from '../../../../../models/aggregates/group';


@Injectable({
  providedIn: 'root'
})
export class TenantUserTeamRoleAssignmentService extends BaseApiTemplateService<LinkSubjectToGroupContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + '/permission/assign';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + '/permission/assign';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + '/permission/assign';
    this.httpClient = http;
  }
}
